<div class="d-flex flex-column py-5"
     style="background: url('/assets/img/dropdown-bg.jpg');background-size: cover;background-position: center;">
  <h5 class="d-flex flex-center">
    <span class="white">{{'lang.reporting.generatedReports' | translate}}</span>
    <a class="ml-2" style="padding: 0; background: none !important;" [sbRouterLink]="util.RoutingID.generatedReport">
            <span class="font-weight-bold btn btn-danger btn-sm">
                {{reportingService.reportCount > 999 ? '999 +' :
              reportingService.reportCount}}
            </span>
    </a>
  </h5>
</div>
<!--- hier den ngFor --->
<div class="navi py-3">
  <ng-scrollbar style="height: 450px" [track]="'vertical'">
    <ng-container *ngFor="let report of reportingService.reportQueue.value">
        <span ngbDropdownItem class="navi-item">
          <div class="navi-link notification-link">
            <div class="navi-text notification-infos">
              <div class="font-weight-bold" [title]="report.name" [innerHTML]="report.name"></div>
            </div>
            <div class="d-flex">
              <button *ngPermissions="permissionService.Permission.device_export"
                      (click)="reportingService.routeToGeneratedReports(report)"
                      ngbTooltip="{{'lang.reporting.generatedReports' | translate}}" placement="right"
                      container="body"
                      class="btn btn-hover-primary btn-sm">
                <sb-icon class="m-0" icon="eye"></sb-icon>
              </button>
            </div>
          </div>
        </span>
    </ng-container>
  </ng-scrollbar>
  <a ngbDropdownItem class="navi-item" (click)="reportingService.clearQueue()">
    <div class="navi-link">
      <div class="navi-attachment mr-2">
        <sb-icon icon="trash" class="red"></sb-icon>
      </div>
      <div class="navi-text">
        <div class="font-weight-bold">
          {{'lang.globals.clear'|translate}}
        </div>
      </div>
    </div>
  </a>
</div>

